import { render } from "./CurriculumEditTable.vue?vue&type=template&id=2509f90c&scoped=true&ts=true"
import script from "./CurriculumEditTable.vue?vue&type=script&lang=ts"
export * from "./CurriculumEditTable.vue?vue&type=script&lang=ts"

import "./CurriculumEditTable.vue?vue&type=style&index=0&id=2509f90c&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2509f90c"]])

export default __exports__